/* eslint-disable */
import { required, email, max,min, alpha_num,alpha,numeric } from 'vee-validate/dist/rules'// eslint-disable-next-line
import { extend, localize } from 'vee-validate';
import zh_TW from 'vee-validate/dist/locale/zh_TW.json' // eslint-disable-next-line

localize({
  zh_TW, 
});
localize('zh_TW');
extend('required', required); // 必填
extend('alpha_num', alpha_num); // 只能數字跟英文
extend('email', email); // email
extend('max', max); //最大用冒號 ex. max:8
extend('min', min); //最小用冒號 ex. max:8
extend('alpha', alpha); // 只能英文字母
extend('numeric', numeric); // 只能數字


// 學員帳號
extend('LDCCAccount',{
  message: (filed) => filed + '不符格式',
  validate: (val) => {
    return /^U\d{6,12}$/.test(val)
  }
})
// 老師帳號
extend('LDCCAccountT',{
  message: (filed) => filed + '不符格式',
  validate: (val) => {
    return /^T\d{6,12}$/.test(val)
  }
})

// 身份證
extend('idNum', {
  message: (field) => field + '有誤',
  validate: (val) => {
    if (!/^[A-Z](1|2)\d{8}$/.test(val)) return false;
    const city = [1, 10, 19, 28, 37, 46, 55, 64, 39, 73, 82, 2, 11, 20, 48, 29, 38, 47, 56, 65, 74, 83, 21, 3, 12, 30];
    let total = city[val.charCodeAt(0) - 65];
    for (let i = 1; i <= 8; i++) {
      total += val.charAt(i) * (9 - i);
    }
    total += val.charAt(9) * 1;
    return total % 10 === 0;
  },
});

// 統一編號
extend('uniNum', {
  message: (field) => field + '有誤',
  validate: (val) => {
    if (!/^\d{8}$/.test(val) || '00000000,11111111'.indexOf(val) !== -1) return false;
    const c = [1, 2, 1, 2, 1, 2, 4, 1];
    let sum = 0;
    const sumOfNum = function (n) {
      return n > 9 ? Math.floor(n / 10) + n % 10 : n;
    };
    for (let i = 0; i < 8; i++) {
      sum += sumOfNum((val.charAt(i)) * c[i]);
    }
    return sum % 10 === 0 || (val.charAt(6) === '7' && sum % 10 === 9);
  },
});

// 手機
extend('mobile', {
  message: (field) => field + '有誤',
  validate: (val) => /^09\d{8}$/.test(val),
});

// 我再看看
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: '不一致',
});

//車牌號碼
extend('licensePlateNumber', {
  validate(value) {
    return /^[A-Z0-9]{6,8}$/.test(value); // ^[A-Z0-9]{2,4}-[A-Z0-9]{2,4}$
  },
  message(field) {
    return field + '不符合規則';
  },
});